import React from "react";
import { FormattedMessage } from "react-intl";
import { Space, Row } from "@masterteam/mt-design-react";

import KPIStatusIndicator from "../../KPIStatusIndicator";

import "./style.scss";

const Statuses = ({ thresholds, projectStatuses }) => {
  return (
    <Row size="large" justify="between" className="statuses-container">
      <Space style={{ flex: 1 }}>
        <div>
          <FormattedMessage id="common.kpi-status" /> :
        </div>

        <Space size="medium" wrap>
          {thresholds.map((_item, index) => (
            <KPIStatusIndicator item={_item} key={index} />
          ))}
        </Space>
      </Space>

      <div className="gray-line" />

      <Space style={{ flex: 1 }}>
        <div>
          <FormattedMessage id="common.project-status" /> :
        </div>

        <Space size="medium" wrap>
          {projectStatuses.map((_item, index) => (
            <KPIStatusIndicator item={_item} key={index} />
          ))}
        </Space>
      </Space>
    </Row>
  );
};

export default Statuses;
